import { Menu, Transition } from '@headlessui/react'
import React, { useState, Fragment, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Navbar = ({ title }) => {

  const userNagivationAccess = useSelector(state => state.userNagivationAccess)

  return (
    <div className='banner'>
      <p>{title}</p>

      <Menu as='div' className='menu'>
        <Menu.Button className='menu__btn group'>
          <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.7} stroke='currentColor' className='w-5 h-5 group-hover:scale-105 transition-all'>
            <path strokeLinecap='round' strokeLinejoin='round' d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5' />
          </svg>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter='transition ease-out duration-100'
          enterFrom='transform opacity-0 scale-95'
          enterTo='transform opacity-100 scale-100'
          leave='transition ease-in duration-75'
          leaveFrom='transform opacity-100 scale-100'
          leaveTo='transform opacity-0 scale-95'
        >
          <Menu.Items className='menu__items'>
            <div className='p-1'>
              {
                userNagivationAccess?.length > 0 &&
                userNagivationAccess.map((route) => (
                  <Menu.Item key={route._id}>
                    {({ active }) => (
                      <NavLink
                        to={`/${route.url}`}
                        className={isActive => `
                          ${isActive ? 'text-primary font-medium' : ''}
                          ${active ? 'bg-primary-light text-primary' : 'text-gray-900'}
                          menu__items-link`
                        }
                      >
                        {route?.name}
                      </NavLink>
                    )}
                  </Menu.Item>
                ))
              }
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}

export default Navbar